<div class="toast-container position-fixed top-0 end-0 p-3">
  <div *ngIf="show" class="toast align-items-center text-white {{ typeClass }}" role="alert">
    <div class="d-flex">
      <div class="toast-body">
        {{ message }}
      </div>
      <button type="button" class="btn-close btn-close-white me-2 m-auto" aria-label="Close" (click)="hideToast()"></button>
    </div>
  </div>
</div>
